<template>   
    <v-container fluid>
        <div class="mt-5 mb-10 ">
            <div class="d-flex flex-row-reverse">
                <v-btn text class="flag-icon-background flag-icon-vn" @click="changeLocaleVN()">
                </v-btn>
    
                <v-btn text class="flag-icon-background flag-icon-gb" @click="changeLocaleEN()">
                </v-btn>
        </div>
    
        </div>
    
        <v-row align="center" justify="center">
            <v-col cols="12" sm="6" xl="4">
                <v-card class="elevation-12">
                    <div class="header">
                        <p class="text-center"> {{ $t('login.greeting') }} </p>
                    </div>
    
                    <v-card-text class="px-10 mt-2">
                        <v-form ref="form" v-model="valid" lazy-validation @keyup.enter.native="login">
                            <v-text-field v-model="email" :rules="emailRules" v-bind:label="$t('login.email')" outlined name="email" prepend-icon="person" type="text" required/>
                            <v-text-field v-model="password" :append-icon="show ? 'visibility' : 'visibility_off'" :rules="passdRules" v-bind:label="$t('login.password')" outlined id="password" name="password" prepend-icon="lock" :type="show ? 'text' : 'password'" required @click:append="show = !show"
                            />
                        </v-form>
    
                        <div class="float-right">
                            <v-btn text large class="text-none small-button" @click="forgot">{{ $t('login.forgot') }}</v-btn>
                        </div>
                    </v-card-text>
    
                    <v-container class="px-12 pt-10" fluid>
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="8" md="8">
                                <v-btn large block color="primary" class="normal-button" @click="login">{{ $t('login.login') }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>


        <v-overlay :value="overlay" :z-index="0">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
    </v-container>
   
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data: () => ({
        show: false,
        valid: true,
        overlay: false,

        password: '',
        passdRules: [
            v => !!v || i18n.t('validate.password_require'),
            v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
        ],
        email: '',
        emailRules: [
            v => !!v || i18n.t('validate.email_require'),
            v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
        ],
    }),

    created() {
    },

    methods: {
        changeLocaleVN: function() {
            this.$i18n.locale = 'vn';
            this.$store.dispatch('language/setLanguage', 'vn');
        },
        changeLocaleEN: function() {
            this.$i18n.locale = 'en';
            this.$store.dispatch('language/setLanguage', 'en');
        },
        forgot: function() {
            this.$router.push('forgot');
        },
        login: async function() {
            this.overlay = true;

            const self = this;
            const requestBody = {
                email: self.email,
                password: self.password
            };


            try {
                const response =  await this.$http.post(process.env.VUE_APP_LOGIN_URL, requestBody);

                this.overlay = false;
                if (response.data && response.data.success) {
                    // console.log(response.data);
                    
                    localStorage.setItem('access_token', response.data.accessToken);

                    return await this.$router.push('/');
                } else if (response.data && !response.data.success) {
                    this.$fire({
                        title: i18n.t('login.error_login'),
                        text: "",
                        type: "error"
                        }); 
                } else {
                    alert("Request error!");
                }


            } catch(e) {
                console.log(e.stack);
                alert("Request error!");
            }
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.snackbar = true
            }
        },
        reset() {
            this.$refs.form.reset()
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
    }
}
</script>

<style scoped>
.header {
    height: 60px;
}

p {
    color: #1D243E;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    padding-top: 20px;
}

.small-button {
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    color: #929AAE;
}

.normal-button {
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
}
</style>
